import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "style", "show", "className", "timeout", "animation"];
import React, { Children } from 'react';
import cn from 'classnames';
import { TransitionGroup } from 'react-transition-group';
import isEmpty from 'lodash/isEmpty';
import CSSTransition from "../CSSTransition";

var CSSTransitionGroup = function CSSTransitionGroup(_ref) {
  var children = _ref.children,
      style = _ref.style,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 225 : _ref$timeout,
      animation = _ref.animation,
      props = _objectWithoutProperties(_ref, _excluded);

  var transitionChildren = Children.toArray(children).filter(function (child) {
    return Boolean(child);
  });

  if (isEmpty(animation)) {
    return children;
  }

  return /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null,
    className: cn('css-transition-group', className),
    style: style,
    "data-qa": "css-transition-group"
  }, React.Children.map(transitionChildren, function (child) {
    var casted = child;
    return /*#__PURE__*/React.createElement(CSSTransition, _extends({
      addEndListener: function addEndListener() {},
      show: show,
      key: casted.key || undefined,
      asGroup: true,
      unmountOnExit: true,
      animation: animation,
      timeout: timeout
    }, props), child);
  }));
};

export default CSSTransitionGroup;